module.exports = __webpack_public_path__ + "img/kv.cc259352.png";